import React from "react";
import Header from "./Component/Header";
import sh1 from "./images/show1.jpg"
// import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
// import 'pure-react-carousel/dist/react-carousel.es.css';
import "./App.css"
import { useEffect } from "react";
import { useState } from "react";
import logo from "./images/aa.jpg";
import Carousel from 'react-bootstrap/Carousel';
import NavBar from "./Component/NavBar";
import Footer from "./Component/Footer";

const Welcome = () => {

    const [activeSlideIndex, setActiveSlideIndex] = useState();

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlideIndex((activeSlideIndex + 1) % 10);
        }, 3000);
        return () => clearInterval(interval);
    }, [activeSlideIndex]);
    return (
        <>
            <Header />
            <NavBar />
            <div class="container py-3 h-100">

                <div class="card rounded-3 text-black">
                    <div class="row g-0">
                        <div class="col-lg-6">
                            <div class="card-body p-md-5 mx-md-4">

                                <div class="col-lg-20 d-flex align-items-center">
                                    <div class="text-black px-3 py-4 p-md-5 mx-md-4">
                                        <div className="col-10 float-left text-center">
                                            <img class="img-fluid" src={logo} alt={logo} width="240" height="186" />
                                        </div>
                                        <h4 class="mb-4">We are more than just a School</h4>
                                        <p class="small mb-0">We are Orgnization where we teach the descipline and CiVilization and Culture of our sociaty
                                         The most important day of a person’s education is the first day of school, not Graduation Day..</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card-body p-md-10 mx-md-9">

                                <div class="col-lg-26 d-flex align-items-center">
                                    <div class="text-black px-2 py-2 p-md-10 mx-md-9">
                                        <div className="col-lg-10 float-left">
                                            <Carousel
                                                interval={500}
                                                autoPlay
                                            >
                                                <Carousel.Item>
                                                    <div className="col-15 float-left ">
                                                        <img class="img-fluid" src={sh1} alt={sh1} width="500" height="286" />
                                                    </div>
                                                    <Carousel.Caption>
                                                        <h3>Modern Convent</h3>
                                                    </Carousel.Caption>
                                                </Carousel.Item>
                                                <Carousel.Item>
                                                    <div className="col-15 float-left m-3">
                                                        <img class="img-fluid" src={logo} alt={sh1} width="500" height="286" />
                                                    </div>

                                                    <Carousel.Caption>
                                                        <h3>Modern Convent</h3>
                                                    </Carousel.Caption>
                                                </Carousel.Item>
                                                <Carousel.Item>
                                                    <div className="col-15 float-left m-3">
                                                        <img class="img-fluid" src={sh1} alt={sh1} width="500" height="286" />
                                                    </div>
                                                    <Carousel.Caption>
                                                        <h3>Modern Convent</h3>
                                                    </Carousel.Caption>
                                                </Carousel.Item>

                                            </Carousel>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );
};
export default Welcome;